@switch (fundAllocationStep) {
  @case (fundAllocationSteps.ALLOCATION_STEP_1) {
    <mat-dialog-content>
      <section class="matDialogTitleSection">
        <h2 class="matDialogTitle matDialogTitleSectionItems">
          {{ fundAllocationsTitles.ALLOCATE_FUNDS }}
        </h2>
      </section>
      <p class="matDialogSubtitle reallocateSubtitle">
        {{ fundAllocationsTitles.ALLOCATE_FUNDS_SUB }}
      </p>
      <form class="fundAllocationsForm" [formGroup]="allocateFundsForm">
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="matDialogFormField"
        >
          <mat-label class="matDialogMatLabel">
            {{ fundAllocationsTitles.SELECT_UNIVERSITY }}
          </mat-label>
          <mat-select formControlName="university">
            @for (university of fundData.activeUniversities; track university) {
              <mat-option [value]="university">
                {{ university }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (
          allocateFundsForm.get("university")?.touched &&
          allocateFundsForm.get("university")?.hasError("required")
        ) {
          <mat-error class="invalidMoveReallocateAmountError">
            *{{ fundAllocationsTitles.SELECT_UNIVERSITY }}
            {{ fundAllocationsMessages.REQUIRED }}
          </mat-error>
        }
      </form>
      <mat-dialog-actions class="matDialogActions">
        <button
          mat-flat-button
          (click)="handleCancel()"
          matDialogClose
          class="matDialogActionButton fundAllocationsPrimaryColorItems"
        >
          {{ fundAllocationButtons.CANCEL }}
        </button>
        <button
          mat-flat-button
          class="matDialogActionButton fundAllocationsPrimaryColorItems"
          (click)="handleNext()"
          [ngClass]="{
            enabledButton: allocateFundsForm.get('university')?.value
          }"
          [disabled]="!allocateFundsForm.get('university')?.value"
        >
          {{ fundAllocationButtons.NEXT }}
        </button>
      </mat-dialog-actions>
    </mat-dialog-content>
  }
  @case (fundAllocationSteps.ALLOCATION_STEP_2) {
    <mat-dialog-content>
      <section class="matDialogTitleSection">
        <mat-icon
          class="fundAllocationsPrimaryColorItems matDialogTitleSectionItems back"
          (click)="handleBack()"
          >chevron_left</mat-icon
        >
        <h2
          class="matDialogTitle matDialogTitleSectionItems"
          (click)="handleBack()"
        >
          {{ fundAllocationsTitles.ALLOCATION_AMOUNT }}
        </h2>
      </section>
      <p class="matDialogSubtitle">
        {{ fundAllocationsTitles.ALLOCATION_AMOUNT_SUB }}
      </p>
      <section class="allocationsDetails">
        <p class="allocateToFrom">
          {{ allocateFundsForm.get("university")?.value }}:
        </p>
        <section class="allocateAmount">
          <p class="allocateFundsFormItems">
            <span class="allocateFundsFormItemsSpan">
              {{ fundAllocationsTitles.CURRENT_ALLOCATION }}
            </span>
            <span class="allocateToFrom allocateFundsFormItemsSpan">
              {{
                checkDecimals(
                  filterUniversityAmounts(
                    allocateFundsForm.get("university")?.value
                  )
                ) | customCurrency
              }}
            </span>
          </p>
          <p class="allocateFundsFormItems">
            <span>
              {{ fundAllocationsTitles.UNALLOCATED_FUNDS }}
            </span>
            <span class="allocateToFrom allocateFundsFormItemsSpan">
              {{ fundData.unallocatedAmount | customCurrency }}
            </span>
          </p>
        </section>
      </section>
      <mat-divider class="allocationsMatDivider"></mat-divider>
      <form class="fundAllocationsForm" [formGroup]="allocateFundsForm">
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="matDialogFormField"
        >
          <mat-label class="matDialogMatLabel">
            {{ fundAllocationsTitles.FUNDS_TO_ALLOCATE }}
          </mat-label>
          <span matPrefix class="prefix">R &nbsp;</span>
          <input
            (input)="handleOnInput()"
            type="number"
            matInput
            appAllowNumbersOnly
            class="matDialogInputField"
            formControlName="allocateFundsInput"
            class="moveInput"
          />
        </mat-form-field>
        @if (
          allocateFundsForm.get("allocateFundsInput")?.touched &&
          allocateFundsForm.get("allocateFundsInput")?.hasError("required")
        ) {
          <mat-error class="invalidMoveReallocateAmountError">
            *{{ fundAllocationsTitles.INPUT_FUNDS }}
            {{ fundAllocationsMessages.REQUIRED }}
          </mat-error>
        }
        @if (
          unallocatedLess &&
          !allocateFundsForm.get("allocateFundsInput")?.hasError("required")
        ) {
          <mat-error class="invalidMoveReallocateAmountError">
            *{{ fundAllocationsMessages.UNALLOCATED_LESS }}
            {{
              allocateFundsForm.get("allocateFundsInput")?.value -
                fundData.unallocatedAmount | customCurrency
            }}
          </mat-error>
        }
        @if (
          universitiesWithCapped.length > 0 &&
          !allocateFundsForm.get("allocateFundsInput")?.hasError("required")
        ) {
          <mat-error class="invalidMoveReallocateAmountError">
            {{ fundAllocationsMessages.CAPPED }}
          </mat-error>
        }
      </form>
      <mat-dialog-actions class="matDialogActions">
        <button
          mat-flat-button
          (click)="handleCancel()"
          matDialogClose
          class="matDialogActionButton fundAllocationsPrimaryColorItems"
        >
          {{ fundAllocationButtons.CANCEL }}
        </button>
        <button
          mat-flat-button
          (click)="handleNext()"
          class="matDialogActionButton fundAllocationsPrimaryColorItems"
          [ngClass]="{
            enabledButton: allocateFundsForm.get('allocateFundsInput')?.value
          }"
          [disabled]="!allocateFundsForm.get('allocateFundsInput')?.value"
        >
          {{ fundAllocationButtons.NEXT }}
        </button>
      </mat-dialog-actions>
    </mat-dialog-content>
  }
  @case (fundAllocationSteps.CONFIRM_ALLOCATION) {
    <mat-dialog-content>
      <section class="matDialogTitleSection">
        <mat-icon
          class="fundAllocationsPrimaryColorItems matDialogTitleSectionItems"
          (click)="handleBack()"
          >chevron_left</mat-icon
        >
        <h2
          class="matDialogTitle matDialogTitleSectionItems"
          (click)="handleBack()"
        >
          {{ fundAllocationsTitles.CONFIRM_ALLOCATION }}
        </h2>
      </section>
      <p class="matDialogSubtitle reallocateSubtitle">
        {{ fundAllocationsTitles.CONFIRM_ALLOCATION_SUB }}
      </p>
      <section class="transferAmountContainer">
        <p class="reallocateToFrom transferAmount">
          {{ fundAllocationsTitles.ALLOCATION_AMOUNT_TITLE }}
        </p>
        <p class="allocateToFrom amount">
          {{
            allocateFundsForm.get("allocateFundsInput")?.value | customCurrency
          }}
        </p>
      </section>
      <mat-divider class="allocationsMatDivider"></mat-divider>
      <ng-container>
        <section class="allocationToFromItem allocationEntityFrom">
          <p class="reallocateToFrom oldNew">{{ fundAllocationsTitles.TO }}</p>
          <p class="allocateToFrom">
            {{ allocateFundsForm.get("university")?.value }}
          </p>
        </section>
        <article class="allocationToFromContainer">
          <section
            class="allocationToFromItem oldNewAllocationFrom oldNewContainer"
          >
            <p class="reallocateToFrom oldNew">
              {{ fundAllocationsTitles.OLD_ALLOCATION }}
            </p>
            <p class="reallocateToFrom oldNew">
              {{ fundAllocationsTitles.NEW_ALLOCATION }}
            </p>
          </section>
          <section class="allocationToFromItem oldNewAmountContainer">
            <p class="oldNew">
              {{
                checkDecimals(
                  filterUniversityAmounts(
                    allocateFundsForm.get("university")?.value
                  )
                ) | customCurrency
              }}
            </p>
            <p class="allocateToFrom oldNew">
              {{
                checkDecimals(
                  filterUniversityAmounts(
                    allocateFundsForm.get("university")?.value
                  ) + allocateFundsForm.get("allocateFundsInput")?.value
                ) | customCurrency
              }}
            </p>
          </section>
        </article>
      </ng-container>
      <mat-dialog-actions class="matDialogActions">
        <button
          mat-flat-button
          (click)="handleCancel()"
          matDialogClose
          class="matDialogActionButton fundAllocationsPrimaryColorItems"
        >
          {{ fundAllocationButtons.CANCEL }}
        </button>
        <button
          mat-flat-button
          class="matDialogActionButton fundAllocationsPrimaryColorItems"
          (click)="handleConfirm()"
          [ngClass]="{
            enabledButton: allocateFundsForm.touched && allocateFundsForm.valid
          }"
          [disabled]="!(allocateFundsForm.touched && allocateFundsForm.valid)"
        >
          {{ fundAllocationButtons.CONFIRM }}
        </button>
      </mat-dialog-actions>
    </mat-dialog-content>
  }
}
